

<div class="progress progress-striped active {{progressClass}}">
  <div role="progressbar " style="width: 100%;" class="progress-bar progress-bar-success"><span style="visibility:hidden">Success</span></div>
</div>
